<div class="maintenance-toast-stack">
  <div
    *ngFor="let alert of alerts; trackBy: trackByKey"
    [@toastSlide]
    class="maintenance-toast"
    [class.maintenance-toast--maintenance]="alert.type === 'maintenance'"
    [class.maintenance-toast--sms]="alert.type === 'sms'"
    [style.cursor]="alert.type === 'sms' ? 'pointer' : 'default'"
    (click)="onAlertClick(alert)">

    <div class="maintenance-toast__icon">
      <span *ngIf="alert.type === 'maintenance'">🔧</span>
      <span *ngIf="alert.type === 'sms'">📩</span>
    </div>

    <div class="maintenance-toast__body">
      <div *ngIf="alert.title" class="maintenance-toast__title">{{ alert.title }}</div>
      <div class="maintenance-toast__message">{{ alert.message }}</div>
    </div>

    <button
      class="maintenance-toast__close"
      (click)="dismiss(alert.key)"
      title="Dismiss">
      ×
    </button>
  </div>
</div>
